<template>
  <v-card>
    <v-card-title class="headline">Racer Support</v-card-title>
    <v-card-subtitle>Your Racer Support earnings</v-card-subtitle>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :server-items-length="total"
        :options.sync="options"
        :loading="loading"
        :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
      >
        <template v-slot:item.dealerNumber="{ item }">
          {{ getDealerNumber(item) }}
        </template>
        <template v-slot:item.serialNumber="{ item }">
          {{ getVin(item) }}
        </template>
        <template v-slot:item.productKey="{ item }">
          {{ getModelCode(item) }}
        </template>
        <template v-slot:item.programCode="{ item }">
          {{ item.promotion?.promotionType?.promotionTypeKey || "N/A" }}
        </template>
        <template v-slot:item.programDescription="{ item }">
          {{ item.promotion?.promotionType?.name || "N/A" }}
        </template>
        <template v-slot:item.payoutAmount="{ item }">
          {{ item.payoutAmount || 0 | toCurrency }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RacerSupports",
  metaInfo: {
    title: "Racer Supports"
  },
  data() {
    return {
      search: "",

      loading: false,
      items: [],
      selectedAwardVehicle: null,
      headers: [
        {
          value: "dealerNumber",
          text: "Dealer Number",
          sortable: false
        },
        {
          value: "serialNumber",
          text: "VIN Number",
          sortable: false,
          align: "center"
        },
        {
          value: "productKey",
          text: "Model Code",
          sortable: false
        },
        {
          value: "programCode",
          text: "Program Code",
          sortable: false
        },
        {
          value: "programDescription",
          text: "Program Description",
          sortable: false
        },
        {
          value: "payoutAmount",
          text: "Amount",
          sortable: true
        }
      ],
      total: 0,
      options: {
        itemsPerPage: 10,
        page: 1,
        sortBy: ["updatedDate"],
        sortDesc: [true]
      }
    };
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    selectedParticipant() {
      this.fetchRacerAwardVehicle();
    }
  },
  created() {
    this.fetchRacerAwardVehicle();
  },
  methods: {
    async fetchRacerAwardVehicle() {
      this.selectedAwardVehicle = null;

      if (!this.selectedParticipant?.id) {
        this.items = [];
        this.total = 0;
        return;
      }

      this.loading = true;

      try {
        const availableAwardVehicles = await this.$awardvehicle.getAvailableAwardVehicles(this.selectedParticipant);
        this.selectedAwardVehicle = availableAwardVehicles.find(av => av?.awardVehicleKey === "RACER_PAYOUTS");
        this.options.page = 1;
        this.getData();
      } catch {
        this.items = [];
        this.total = 0;
        this.loading = false;
      }
    },
    getData() {
      if (!this.selectedParticipant?.id || !this.selectedAwardVehicle?.id) {
        this.items = [];
        this.total = 0;
        this.loading = false;
        return;
      }

      this.loading = true;
      const params = this.$util.buildPaginationParams(this.options);
      params.append("expand", "organization");
      params.append("expand", "sale.organization");
      params.append("expand", "saleProduct.product");
      params.append("expand", "promotion.promotionType");

      let filters = {
        participant: { id: this.selectedParticipant.id },
        awardVehicle: { id: this.selectedAwardVehicle.id },
        hasSale: true,
        isEffective: true
      };
      if (this.search && this.search.trim().length > 0) {
        filters.keyword = this.search.trim();
      }

      this.$api
        .post(`/api/payouts/search?${params.toString()}`, filters)
        .then(({ data }) => {
          this.loading = false;
          this.items = data.content;
          this.total = data.totalElements;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getDealerNumber(item) {
      return item.sale?.organization?.organizationKey || "N/A";
    },
    getVin(item) {
      return item.saleProduct?.serialNumber || "N/A";
    },
    getModelCode(item) {
      return item.saleProduct?.product?.productKey || "N/A";
    }
  },
  computed: {
    ...mapGetters(["selectedParticipant", "selectedClient"])
  }
};
</script>
